// @ts-nocheck — disabled until filmoscope supports player tracker data
import { useEffect } from 'react';
import { useAnalytics, useFeatureFlags } from '@funtech-int/yango-shared';

import { FilmoscopeApi } from '@kinopoisk-int/filmoscope';

import {
    createAnalyticsEvents,
    type PlayerEventParams,
} from '@/scenarios/player/lib/createAnalyticsEvents';

import { usePlayback } from './usePlayback';

interface PlayerAnalyticsParams {
    filmoscopeInstance: FilmoscopeApi | null;
    contentId: string;
    psid: string;
    manifestUrl: string | null;
}

export function usePlayerAnalytics({
    filmoscopeInstance,
    contentId,
    psid,
    manifestUrl,
}: PlayerAnalyticsParams) {
    const playback = usePlayback();
    const { flags } = useFeatureFlags();
    const isDynamicPrerollEnabled = flags.get('isDynamicPrerollEnabled', 'boolean', false);

    const analytics = useAnalytics(createAnalyticsEvents);

    useEffect(() => {
        if (!filmoscopeInstance) return;

        const getEventParams = (): PlayerEventParams => ({
            contentId,
            psid,
            manifestUrl: manifestUrl ?? '',
            contentTypename: playback.contentTypename,
            vsid: playback.vsid.value,
            isDynamicPrerollEnabled,
        });

        const unsubStart = filmoscopeInstance.listen('playbackstart', () => {
            analytics.contentStarted(getEventParams());
        });

        const unsubEnd = filmoscopeInstance.listen('ended', () => {
            if (filmoscopeInstance.ended) {
                analytics.contentFinished(getEventParams());
            }
        });

        return () => {
            unsubStart();
            unsubEnd();
        };
    }, [
        filmoscopeInstance,
        analytics,
        contentId,
        psid,
        manifestUrl,
        playback.contentTypename,
        isDynamicPrerollEnabled,
        playback,
    ]);
}
